import type { ReactNode } from 'react';

import { familleDe, libelleDe, type Statut } from '../../theme/statuts.ts';

/**
 * Badge à puce — un STATUT, jamais une couleur.
 *
 * Le composant reçoit un statut métier ; la teinte vient de
 * `theme/statuts.ts`. Le même statut porte donc la même couleur dans toute
 * l'application — et sur un registre de comptes, la couleur est ce qu'on lit
 * en premier. Un « payé » vert au tableau de bord et brun dans les ventes
 * obligerait à réapprendre le code à chaque écran.
 *
 * [libelle] change le texte sans changer la famille : « Payé » et « Soldé »
 * disent la même chose et doivent se voir pareil.
 */
export function Badge({
  statut,
  libelle,
}: {
  statut: Statut;
  libelle?: string;
}): ReactNode {
  return (
    <span className={`badge badge-${familleDe(statut)}`}>
      {libelle ?? libelleDe(statut)}
    </span>
  );
}
